/** Deep link into Pipedrive. Domain comes from server config via /api/me —
 *  app.pipedrive.com is the fallback (Pipedrive redirects it to your company). */
export function pdRecordUrl(
  domain: string | null | undefined,
  entity: 'person' | 'organization' | 'deal',
  pdId: number | string,
): string {
  return `https://${domain ?? 'app'}.pipedrive.com/${entity}/${pdId}`;
}
